import { useSelector } from 'react-redux';

import { OrderDetailsCustomLayout } from '../constants/features';
import Global from '../store/global-selectors';

/**
 * Hook to check if the OrderDetailsCustomLayout feature is enabled for the current seller
 * @returns {boolean} True if OrderDetailsCustomLayout feature is enabled via Labs page
 */
export const useHasOrderDetailsCustomLayoutFeature = () => {
  const sellerFeatures = useSelector(Global.selectSellerSellerFeatures);
  return sellerFeatures?.includes(OrderDetailsCustomLayout) ?? false;
};
